import {createFileRoute} from '@tanstack/react-router';
import ClubTeamsPage from '../../../../players/ClubTeamsPage.tsx';
import PlayersView from '../../../../players/PlayersView.tsx';
import {useSports} from '../../../../sports/registry.ts';

// The football area's club page. With football v2 it is Club Players — the football players
// first, the teams beside them (see ClubPlayersTable); without it, Club Teams as every
// team-sport area has.
export const Route = createFileRoute('/_app/football/teams/')({
    component: RouteComponent,
});

function RouteComponent() {
    const {data: registry} = useSports();
    return registry?.multi_sport && registry?.football_v2 ? <PlayersView /> : <ClubTeamsPage sport="football" />;
}
